import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';
import { PublishedEvent } from 'shell/models/pubblished-event';

export interface transformPublishedEventResponse {
  id?: number;
  eventTypeCode?: string;
  dateTimePublication?: DateTime | null;
  eventData?: string;
  eventDescription?: string;
}

export const transformPublishedEvent = (
  response: AxiosResponse<HttpResponse<PublishedEvent>>
): transformPublishedEventResponse => {
  const data: PublishedEvent = response.data.payload || {};
  const res: transformPublishedEventResponse = {
    id: data?.id,
    eventTypeCode: data?.codiceTipoEvento ? data?.codiceTipoEvento : '',
    eventData: data?.payload,
    dateTimePublication: data?.dataOraPubblicazione
      ? DateTime.fromISO(data?.dataOraPubblicazione)
      : null,
    eventDescription: data?.descrizioneTipoEvento,
  };
  return res;
};
